import { useState, useEffect, useRef } from "react";
import { ArrowUp } from "lucide-react";

const SCROLL_THRESHOLD = 400;

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  // Track the side of the threshold we're currently on so the
  // scroll handler can short-circuit when nothing's changed.
  // Without this, every scroll event called setVisible(window.scrollY > 400)
  // — even though React bails on a same-value setState, the comparison
  // and re-evaluation still runs on every scroll tick. With a high-
  // frequency input device (mouse wheel, smooth iOS scroll) that's
  // dozens of times per second.
  const wasVisibleRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      const next = window.scrollY > SCROLL_THRESHOLD;
      if (next !== wasVisibleRef.current) {
        wasVisibleRef.current = next;
        setVisible(next);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  // --bottom-bar-h: height of a page's fixed bottom bar while it is showing
  // (the campaign page's mobile CTA bar sets it), so the button sits above it.
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-[calc(1.5rem+var(--bottom-bar-h,0px))] right-6 z-40 w-11 h-11 bg-primary text-primary-foreground rounded-full shadow-lg flex items-center justify-center hover:bg-primary/90 transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 animate-fade-in"
      aria-label="Voltar ao topo"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};

export default BackToTop;
